let buttonClasses = [
  {
    classes: ['btn', 'btn-default'],
    type: 'default',
    style: {color: '#000'},
    background: {
      color: '#CCC'
    }
  },
  {
    classes: ['btn', 'fus-btn-white'],
    type: 'white',
    style: {color: '#FFF'},
    background: {
      color: '#555'
    }
  },
  {
    classes: ['btn', 'btn-primary'],
    type: 'primary',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  }
];

export default buttonClasses;
